// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"e667eef7","672":"7a3bbd30","681":"450d6471","845":"f8ae6018"}[chunkId] + ".chunk.js";
};